import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';
import notificationsFunctional from './index.function';
// import Button from '../../components/Button';
import { RowView } from '../../components';
import LoaderModal from '../../components/LoaderModal';

const Notifications = () => {
  const {
    TextWeight,
    isArabic,
    navigate,
    // selectedTab,
    // onPressTab,
    groupedNotifications,
    notificationLoading,
    getContentKey,
  } = notificationsFunctional();

  return (
    <div className='min-h-full'>
      <ViewReverse className='justify-between items-center flex-wrap gap-3'>
        <ViewReverse className='gap-5 items-center'>
          <ReactSVG
            src={icons?.backSmall}
            className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')}
            onClick={() => navigate(-1)}
          />
          <Text
            text={getContentKey('notifications')}
            color='text-black'
            size={fontSizes.h18}
            weight={TextWeight.bold}
          />
        </ViewReverse>

        {/* <ViewReverse className='gap-3'>
          <Button
            text={getContentKey('all')}
            onClick={() => onPressTab('all')}
            bgColor={selectedTab === 'all' ? 'bg-primary/10' : 'bg-silver-bg'}
            color={selectedTab === 'all' ? 'text-primary' : 'text-silver-text'}
            className='px-14 md:px-20 normal-case'
          />
          <Button
            text={getContentKey('unread')}
            onClick={() => onPressTab('unread')}
            bgColor={selectedTab === 'unread' ? 'bg-primary/10' : 'bg-silver-bg'}
            color={selectedTab === 'unread' ? 'text-primary' : 'text-silver-text'}
            className='px-14 md:px-20 normal-case'
          />
        </ViewReverse> */}
      </ViewReverse>

      {groupedNotifications?.length > 0 ? (
        groupedNotifications?.map((group) => (
          <div key={group?.label} className='mt-6'>
            <Text
              text={group?.label}
              size={fontSizes.h18}
              weight={TextWeight.bold}
              color='text-black'
            />
            <RowView className='mt-6 flex-col gap-4'>
              {group?.items?.map((item) => (
                <div
                  key={item?.id}
                  className='relative border border-grey rounded-xl px-5 py-4'
                >
                  <RowView className={'justify-between items-center'}>
                    <Text
                      text={item?.time}
                      size={fontSizes.h11}
                      color='text-silver'
                      weight={TextWeight.regular}
                    />
                    {!item?.isRead && (
                      <div className='w-2 h-2 rounded-full bg-notification-green'></div>
                    )}
                  </RowView>
                  <Text
                    text={item?.title}
                    size={fontSizes.h15}
                    weight={TextWeight.semiBold}
                    color='text-black'
                    className='mt-1'
                  />
                  <Text
                    text={item?.description}
                    size={fontSizes.h12}
                    color='text-silver'
                    isTruncate={false}
                    className='mt-1'
                  />
                </div>
              ))}
            </RowView>
          </div>
        ))
      ) : (
        !notificationLoading && (
          <Text
            text={getContentKey('no_notifications_available')}
            color='text-black'
            size={fontSizes.h20}
            className='mt-28 text-center'
          />
        )
      )}

      <LoaderModal open={notificationLoading} />
    </div>
  );
};

export default Notifications;
